import { h } from "preact";
import { css } from "emotion";

const container = css({
  display: "flex"
});

const charityStyle = css({
  borderRadius: 44,
  width: 44,
  height: 44,
  minWidth: 44,
  margin: "0 16px 0 0"
});

const OrderCharityMsg = ({ charity }) => {
  if (!charity) {
    return null;
  }
  const charityUrl = `https://cdn.filestackcontent.com/resize=width:150/${
    charity.logo.handle
  }`;
  const charityBg = css({
    background: `url(${charityUrl}) no-repeat center`,
    backgroundSize: "cover"
  });
  return (
    <div className={container}>
      <div className={css([charityStyle, charityBg])} />
      <div>
        <h4 style={{ fontWeight: 600, margin: 0 }}>Thank you!</h4>
        <p style={{ margin: 0 }}>
          100% of profits from Humanitix fees are funding{" "}
          <a
            style={{ textDecoration: "underline" }}
            href={charity.website}
            target="_blank"
          >
            {charity.name}
          </a>
        </p>
      </div>
    </div>
  );
};
export default OrderCharityMsg;



// WEBPACK FOOTER //
// ./components/OrderCharityMsg.js